import api, { transformRequest, transformResponse } from "services/api";

export const processServerApi = api
  .enhanceEndpoints({ addTagTypes: ["ProcessServers"] })
  .injectEndpoints({
    endpoints: (build) => ({
      fetchProcessServers: build.query({
        query: () => "/api/v1/core/process-servers/",
        transformResponse: (response) => transformResponse(response),
        providesTags: (results) =>
          results
            ? // successful query
              [
                ...results.map(({ id }) => ({ type: "ProcessServers", id })),
                { type: "ProcessServers", id: "LIST" },
              ]
            : // an error occurred, but we still want to refetch this query when `{ type: 'ProcessServers', id: 'LIST' }` is invalidated
              [{ type: "ProcessServers", id: "LIST" }],
      }),
      addProcessServer: build.mutation({
        query: (payload) => ({
          url: "/api/v1/core/process-servers/create/",
          method: "POST",
          body: transformRequest(payload),
        }),
        transformResponse: (response) => transformResponse(response),
        // Invalidates all ProcessServers-type queries providing the `LIST` id - after all, depending of the sort order,
        invalidatesTags: [{ type: "ProcessServers", id: "LIST" }],
      }),
      updateProcessServer: build.mutation({
        query: (payload) => ({
          url: `/api/v1/core/process-servers/${payload.processServerId}/update/`,
          method: "POST",
          body: transformRequest(payload),
        }),
        transformResponse: (response) => transformResponse(response),
        // Invalidates all ProcessServers-type queries providing the `LIST` id - after all, depending of the sort order,
        invalidatesTags: [{ type: "ProcessServers", id: "LIST" }],
      }),
      deleteProcessServer: build.mutation({
        query: (payload) => ({
          url: `/api/v1/core/process-servers/${payload.processServerId}/delete/`,
          method: "POST",
        }),
        // Invalidates all ProcessServers-type queries providing the `LIST` id - after all, depending of the sort order,
        invalidatesTags: [{ type: "ProcessServers", id: "LIST" }],
      }),
    }),
  });

export const {
  useFetchProcessServersQuery,
  useAddProcessServerMutation,
  useUpdateProcessServerMutation,
  useDeleteProcessServerMutation,
} = processServerApi;
